import { render, staticRenderFns } from "./ShopifyIntegrationView.vue?vue&type=template&id=33512184&lang=pug&"
import script from "./ShopifyIntegrationView.vue?vue&type=script&lang=js&"
export * from "./ShopifyIntegrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports